import { cn } from '../../utils/cn'
import { Button } from './Button'

interface EmptyStateAction {
  label: string
  onClick: () => void
  variant?: 'default' | 'outline'
  icon?: React.ReactNode
}

interface EmptyStateProps {
  icon: React.ReactNode
  title: string
  description: string
  encouragement?: string
  actions?: EmptyStateAction[]
  className?: string
}

export function EmptyState({ icon, title, description, encouragement, actions, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center text-center py-12 px-6', className)}>
      <div className="w-16 h-16 rounded-2xl bg-brand-subtle flex items-center justify-center mb-4">
        {icon}
      </div>
      <h3 className="text-lg font-semibold text-primary mb-1.5">{title}</h3>
      <p className="text-sm text-secondary max-w-sm mb-2 leading-relaxed">{description}</p>
      {encouragement && (
        <p className="text-sm text-brand font-medium max-w-sm mb-4 italic">
          {encouragement}
        </p>
      )}
      {actions && actions.length > 0 && (
        <div className="flex flex-wrap items-center justify-center gap-3 mt-2">
          {actions.map((action, i) => (
            <Button
              key={i}
              onClick={action.onClick}
              variant={action.variant || (i === 0 ? 'default' : 'outline')}
              className="min-h-touch"
            >
              {action.icon}
              {action.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  )
}
